import { createSelector, createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../actions/SetDefinitions';
const initialState = {};
export const actionsSlice = createSlice({
    name: 'actions',
    initialState,
    reducers: {
        actionsCleared: () => {
            return {};
        },
        actionUpdated: (state, action) => {
            state[action.payload.id] = action.payload;
        },
        actionDeleted: (state, action) => {
            delete state[action.payload];
        },
        actionsReplaced: (state, action) => {
            const newState = {};
            for (const o of action.payload) {
                newState[o.id] = o;
            }
            return newState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setDefinitions, (_, action) => {
            const newState = {};
            for (const o of action.payload.actions) {
                newState[o.id] = o;
            }
            return newState;
        });
    }
});
export const selectActions = (state) => state.definitions.actions;
export const selectAction = (id) => (state) => id == undefined ? undefined : state.definitions.actions[id];
const selectDeviceId = (_state, deviceId) => deviceId;
export const selectActionsForDevice = createSelector([selectActions, selectDeviceId], (actions, device_id) => {
    const deviceActions = [];
    for (const a of Object.values(actions)) {
        if (a.device_id == device_id) {
            deviceActions.push(a);
        }
    }
    return deviceActions;
});
export const { actionsCleared, actionUpdated, actionDeleted, actionsReplaced } = actionsSlice.actions;
export const actionAdded = actionUpdated;
export default actionsSlice.reducer;
